import React from 'react';
import { Box, Button, Popover, MenuItem, Switch, Theme, Typography } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import { ExpandMore } from '@material-ui/icons';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toolbarButton: {
      backgroundColor: 'transparent',
      color: '#646464',
      border: '1px solid #d9d9d9',
      borderRadius: '4px',
      padding: '4.5px 12px',
      fontSize: '12px',
      fontWeight: 600,
      textTransform: 'none',
      minWidth: 'auto',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
    optionItem: {
      fontSize: '13px',
      padding: '4px 12px 4px 16px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      minWidth: '260px',
      '&:hover': {
        backgroundColor: theme.color.grey.neutralBrand100,
      },
    },
    optionDescription: {
      fontSize: '11px',
      color: theme.color.grey.neutral300,
    },
  })
);

interface ViewOptionsPopoverProps {
  showUnanswered: boolean;
  showHeadings: boolean;
  headingsAvailable: boolean;
  onShowUnansweredChange: (value: boolean) => void;
  onShowHeadingsChange: (value: boolean) => void;
}

export const ViewOptionsPopover: React.FC<ViewOptionsPopoverProps> = ({
  showUnanswered,
  showHeadings,
  headingsAvailable,
  onShowUnansweredChange,
  onShowHeadingsChange,
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  return (
    <>
      <Button
        endIcon={<ExpandMore style={{ fontSize: '16px' }} />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        className={classes.toolbarButton}
      >
        <>
          View:{' '}
          <span style={{ fontWeight: 400, marginLeft: '4px' }}>{showUnanswered ? 'All questions' : 'Answered'}</span>
        </>
      </Button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem className={classes.optionItem} onClick={() => onShowUnansweredChange(!showUnanswered)}>
          <Box>
            <Typography style={{ fontSize: '13px' }}>All questions</Typography>
            <Typography className={classes.optionDescription}>Include questions left blank</Typography>
          </Box>
          <Switch size='small' color='primary' checked={showUnanswered} />
        </MenuItem>
        {headingsAvailable && (
          <MenuItem className={classes.optionItem} onClick={() => onShowHeadingsChange(!showHeadings)}>
            <Box>
              <Typography style={{ fontSize: '13px' }}>Group by section</Typography>
              <Typography className={classes.optionDescription}>Use the form&apos;s headings</Typography>
            </Box>
            <Switch size='small' color='primary' checked={showHeadings} />
          </MenuItem>
        )}
      </Popover>
    </>
  );
};
